import { chakra, defineRecipe } from '@plurall/elo-v3';

const headerRecipe = defineRecipe({
  className: 'edit-goal-modal__header',
  base: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 'gap.xsmall',
    paddingTop: 'padding.xlarge',
  },
});

const headerTitleGroupRecipe = defineRecipe({
  className: 'edit-goal-modal__header-title-group',
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'padding.3xsmall',
    minWidth: 0,
  },
});

const titleRecipe = defineRecipe({
  className: 'edit-goal-modal__title',
  base: {
    margin: 0,
    fontSize: 'font.size.large',
    fontWeight: 'font.weight.semi.bold',
    lineHeight: '150%',
    color: 'text.primary',
  },
});

const closeButtonRecipe = defineRecipe({
  className: 'edit-goal-modal__close-button',
  base: {
    display: 'flex',
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'center',
    width: 'size.32',
    height: 'size.32',
    margin: 0,
    padding: 0,
    background: 'none',
    border: 'none',
    borderRadius: 'border.radius.full',
    cursor: 'pointer',
    color: 'text.primary',
    _hover: {
      backgroundColor: 'action.hover.standard',
    },
  },
});

const subtitleRecipe = defineRecipe({
  className: 'edit-goal-modal__subtitle',
  base: {
    margin: 0,
    fontSize: 'font.size.small',
    fontWeight: 'font.weight.regular',
    lineHeight: '150%',
    color: 'text.tertiary',
  },
});

const sectionRecipe = defineRecipe({
  className: 'edit-goal-modal__section',
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'gap.3xsmall',
    marginTop: 'padding.xlarge',
  },
});

const fieldLabelRecipe = defineRecipe({
  className: 'edit-goal-modal__field-label',
  base: {
    margin: 0,
    marginBottom: 'padding.3xsmall',
    fontSize: 'font.size.small',
    fontWeight: 'font.weight.semi.bold',
    color: 'text.primary',
  },
});

const inputWrapperRecipe = defineRecipe({
  className: 'edit-goal-modal__input-wrapper',
  base: {
    position: 'relative',
    width: '100%',
  },
});

const inputSuffixRecipe = defineRecipe({
  className: 'edit-goal-modal__input-suffix',
  base: {
    position: 'absolute',
    top: '50%',
    right: 'padding.large',
    transform: 'translateY(-50%)',
    fontSize: 'font.size.small',
    fontWeight: 'font.weight.regular',
    color: 'text.tertiary',
    pointerEvents: 'none',
  },
});

const helperTextRecipe = defineRecipe({
  className: 'edit-goal-modal__helper-text',
  base: {
    margin: 0,
    fontSize: 'font.size.xsmall',
    fontWeight: 'font.weight.regular',
    color: 'text.tertiary',
  },
});

const cancelButtonRecipe = defineRecipe({
  className: 'edit-goal-modal__cancel-button',
  base: {
    display: 'flex',
    alignItems: 'center',
    margin: 0,
    padding: 'padding.xsmall padding.large',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: 'font.size.small',
    fontWeight: 'font.weight.semi.bold',
    color: 'foreground.brand',
  },
});

export const EditGoalModalHeaderFactory = chakra('div', headerRecipe);
export const EditGoalModalHeaderTitleGroupFactory = chakra('div', headerTitleGroupRecipe);
export const EditGoalModalTitleFactory = chakra('h2', titleRecipe);
export const EditGoalModalCloseButtonFactory = chakra('button', closeButtonRecipe);
export const EditGoalModalSubtitleFactory = chakra('p', subtitleRecipe);
export const EditGoalModalSectionFactory = chakra('div', sectionRecipe);
export const EditGoalModalFieldLabelFactory = chakra('p', fieldLabelRecipe);
export const EditGoalModalInputWrapperFactory = chakra('div', inputWrapperRecipe);
export const EditGoalModalInputSuffixFactory = chakra('span', inputSuffixRecipe);
export const EditGoalModalHelperTextFactory = chakra('p', helperTextRecipe);
export const EditGoalModalCancelButtonFactory = chakra('button', cancelButtonRecipe);
